import script from "./ArticleView.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleView.vue?vue&type=script&setup=true&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=3e4146f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4146f8"]])

export default __exports__